import { faStepForward } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { ColumnDescription, SelectRowProps } from "react-bootstrap-table-next";
import { useRegistrarAcordoContext } from "..";
import SpinnerUAU from "../../../../../Components/Loding/SpinnerUAU";
import Table from "../../../../../Components/Table";
import { IParcelaBoletos } from "../../../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";
import { IParcelasComDescontos } from "../../../../../Interfaces/Cobranca/Renegociacao/RenegociacaoInterfaces";
import { formatMoneyReais } from "../../../../../Tools/FormatTools";

interface IEscolhaDeParcelasProps {}

export default function EscolhaDeParcelas(props: IEscolhaDeParcelasProps) {
    const {
        goToStep,
        lstTodasParcelas,
        selecionarParcelas,
        setParcelasReq,
        parcelasReq,
    } = useRegistrarAcordoContext();

    const [lstParcelas, setlstParcelas] = useState<Array<IParcelaBoletos>>();
    const [loading, setLoading] = useState(false);
    const [enableNextStep, setEnableNextStep] = useState(false);
    const [lstSelecionados, setlstSelecionados] =
        useState<Array<IParcelaBoletos>>();

    useEffect(() => {
        setLoading(true);
        lstTodasParcelas
            .get()
            .then((res) => {
                setlstParcelas(res);

                setEnableNextStep((lstSelecionados?.length || 0) > 0);
            })
            .finally(() => setLoading(false));
    }, [lstSelecionados, lstTodasParcelas]);

    const getNonSelectableRows = (
        payload: IParcelaBoletos[] | undefined,
        key: "FL_PODE_GERAR",
        stringToCheck: boolean
    ) => {
        let nonSelectable: Array<number> = [];

        payload?.forEach((obj, index) => {
            let value = obj[key];
            if (value !== Boolean(stringToCheck)) {
                nonSelectable.push(index);
            }
        });

        return nonSelectable;
    };

    const selectRowProp: SelectRowProps<IParcelaBoletos> = {
        mode: "checkbox",
        clickToSelect: true,
        nonSelectable: getNonSelectableRows(lstParcelas, "FL_PODE_GERAR", true),
        selected: lstSelecionados?.map((p) => p.idParcelaCapys),

        onSelect: (row, isSelect, rowIndex, e) => {
            setlstSelecionados((prevSelecionados) => {
                if (isSelect) {
                    return [...(prevSelecionados ?? []), row];
                } else {
                    return (
                        prevSelecionados?.filter(
                            (selec) =>
                                selec.idParcelaCapys !== row.idParcelaCapys
                        ) || []
                    );
                }
            });
        },

        onSelectAll: (isSelect, rows) => {
            setlstSelecionados((prevSelecionados) => {
                if (isSelect) {
                    return [...(prevSelecionados ?? []), ...rows];
                } else {
                    return (
                        prevSelecionados?.filter(
                            (selec) =>
                                !rows.some(
                                    (row) =>
                                        row.idParcelaCapys ===
                                        selec.idParcelaCapys
                                )
                        ) || []
                    );
                }
            });
        },
    };
    const handleSelecionarParcelasConfirma = () => {
        selecionarParcelas(lstSelecionados ?? []);
        goToStep("selecDescontos");
    };

    return (
        <div className="mt-5">
            <h3>Selecione as parcelas para a renegociação:</h3>
            <div className="row">
                <div className="col-12 col-sm-6">
                    <label className="text-muted mb-0"> Data de Cálculo</label>
                    <input
                        type="date"
                        className={`form-control px-0 p-2`}
                        defaultValue={parcelasReq.DT_CALCULO}
                        onBlur={(e) => {
                            const DT_CALCULO = e.target.value;
                            if (
                                DT_CALCULO &&
                                DT_CALCULO !== parcelasReq.DT_CALCULO
                            ) {
                                setParcelasReq({
                                    DT_CALCULO,
                                });
                            }
                        }}
                    />
                </div>
                <div className="col-12 col-sm-6">
                    <div className="d-flex align-items-center justify-content-center">
                        <span>Antecipacao</span>
                    </div>
                    <span
                        className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center align-items-center mt-1"
                        data-toggle="tooltip"
                    >
                        <label>
                            <input
                                type="checkbox"
                                defaultChecked={parcelasReq.FL_ANTECIPACAO}
                                onChange={(e) => {
                                    const FL_ANTECIPACAO = e.target.checked;
                                    setParcelasReq({
                                        FL_ANTECIPACAO,
                                    });
                                }}
                            />
                            <span></span>
                        </label>
                    </span>
                </div>
            </div>
            <div>
                {lstParcelas ? (
                    <Table
                        data={lstParcelas}
                        columns={columns}
                        keyField="idParcelaCapys"
                        bordered={false}
                        rowClasses="border-bottom border-gray checkbox-table"
                        sizePerPage={lstParcelas.length}
                        selectRow={selectRowProp}
                        loading={loading}
                        tableView={{
                            columns: columnsTableView,
                        }}
                        wrapperClasses="y-scroll maxHeight-300 mb-2"
                        noPagination
                        noSearch
                    />
                ) : loading ? (
                    <SpinnerUAU />
                ) : (
                    <>Não foi possível carregar</>
                )}
            </div>
            <div className="d-flex justify-content-end mt-5">
                <button
                    disabled={!enableNextStep}
                    className="btn btn-primary"
                    onClick={handleSelecionarParcelasConfirma}
                >
                    Selecionar Parcelas
                    <FontAwesomeIcon className="ml-2" icon={faStepForward} />
                </button>
            </div>
        </div>
    );
}

//Tabela
const columns: Array<ColumnDescription> = [
    {
        dataField: "NumParc_Prc",
        text: "Parcelas",
        formatter: row,
        headerClasses: "d-none",
    },
];

const columnsTableView: Array<ColumnDescription<IParcelasComDescontos>> = [
    {
        dataField: "Tipo_Prc",
        text: "Parcela",
        classes: "p-3 ws-nowrap",
        formatter: (c, row) => {
            const data = new Date(row.Data_Prc);
            return (
                <span
                    className={data.getTime() < Date.now() ? "text-danger" : ""}
                >
                    {`${c} - ${row.Descricao_par} - ${row.NumParc_Prc}`}
                </span>
            );
        },
        headerAlign: "center",
    },
    {
        dataField: "Data_Prc",
        text: "Data de Vencimento",
        formatter: (c) => {
            const data = new Date(c);
            return (
                <span
                    className={data.getTime() < Date.now() ? "text-danger" : ""}
                >
                    {new Date(c).toLocaleDateString()}
                </span>
            );
        },
        classes: "p-3 ws-nowrap",
        align: "center",
        headerAlign: "center",
    },
    {
        dataField: "ValorReaj",
        text: "Valor Reajus.",
        formatter: (c, row) => {
            const data = new Date(row.Data_Prc);
            return (
                <span
                    className={data.getTime() < Date.now() ? "text-danger" : ""}
                >
                    {formatMoneyReais(c)}
                </span>
            );
        },
        classes: "p-3 ws-nowrap",
        align: "center",
        headerAlign: "center",
    },
    {
        dataField: "Valor_Prc",
        text: "Valor Principal",
        formatter: (c, row) => {
            const data = new Date(row.Data_Prc);
            return (
                <span
                    className={data.getTime() < Date.now() ? "text-danger" : ""}
                >
                    {formatMoneyReais(c)}
                </span>
            );
        },
        classes: "p-3 ws-nowrap",
        align: "center",
        headerAlign: "center",
    },
    {
        dataField: "ValorMulta",
        text: "Multa",
        formatter: (c, row) => {
            const data = new Date(row.Data_Prc);
            return (
                <span
                    className={data.getTime() < Date.now() ? "text-danger" : ""}
                >
                    {formatMoneyReais(c)}
                </span>
            );
        },
        classes: "p-3 ws-nowrap",
        align: "center",
        headerAlign: "center",
    },
    {
        dataField: "vlrJurosAtraso",
        text: "Juros",
        formatter: (c, row) => {
            const data = new Date(row.Data_Prc);
            return (
                <span
                    className={data.getTime() < Date.now() ? "text-danger" : ""}
                >
                    {formatMoneyReais(c)}
                </span>
            );
        },
        classes: "p-3 ws-nowrap",
        align: "center",
        headerAlign: "center",
    },
];

function row(cell: any, row: IParcelaBoletos) {
    const parcelaVencida = new Date(row.Data_Prc).getTime() < Date.now();

    return (
        <div className="w-100 ml-auto mb-2">
            <div className="w-100 p-3">
                <div className="d-flex flex-wrap align-itens-center justify-content-between mb-2">
                    <big className="font-weight-bolder">
                        <span className="text-dark-75">
                            {row.Tipo_Prc} - {row.NumParc_Prc}
                        </span>
                    </big>
                    <div className="d-flex flex-wrap align-items-center justify-content-center g-2">
                        <div className="d-flex flex-wrap align-itens-center justify-content-center g-3">
                            <div className="d-flex flex-wrap flex-column mr-1">
                                <span className="d-block font-weight-bold">
                                    Data de Competência
                                </span>
                                <span
                                    className={`label label-light-${
                                        parcelaVencida ? "danger" : "primary"
                                    } label-inline mr-2 my-1`}
                                >
                                    {moment(row.Data_Prc).format("MM/yy")}
                                </span>
                            </div>
                            <div className="d-flex flex-wrap flex-column">
                                <span className="d-block font-weight-bold">
                                    Data Vencimento
                                </span>
                                <span
                                    className={`label label-light-${
                                        parcelaVencida ? "danger" : "primary"
                                    } label-inline mr-2 my-1`}
                                >
                                    {moment(row.Data_Prc).format("DD/MM/yy")}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="d-flex flex-wrap justify-content-between mr-1">
                    <div className="d-flex flex-column mb-1">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Valor Reajus.
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {formatMoneyReais(row.ValorReaj)}
                        </span>
                    </div>
                    <div className="d-flex flex-column mb-1">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Valor Principal
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {formatMoneyReais(row.Valor_Prc)}
                        </span>
                    </div>
                    <div className="d-flex flex-column mb-1">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Multa
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {formatMoneyReais(row.ValorMulta)}
                        </span>
                    </div>
                    <div className="d-flex flex-column mb-1">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Juros
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {formatMoneyReais(row.vlrJurosAtraso)}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}
